import { Tooltip } from '@bp/ui-components';
import dayjs from 'dayjs';
import styles from './TimetableBlock.module.scss';

type TodayMarkerProps = {
  /** Position auf der Schuljahres-Achse in Prozent [0, 100]. */
  percent: number;
  /** Dunkelgelbe Fläche links der Linie (nur für die farbigen Reihen). */
  withFill?: boolean;
  /** Heute-Linie zeigen. Bei komplett vergangenem Schuljahr false (Fläche 100 %, keine Linie). */
  showLine?: boolean;
};

/**
 * "Heute"-Strich-Segment für eine einzelne Reihe. Wird pro Reihe gerendert
 * (statt einer durchgezogenen Linie über alle Reihen), damit die Abstände zwischen
 * den Reihen frei bleiben. Die umgebende Reihe muss position: relative sein.
 */
export const TodayMarker = ({ percent, withFill = false, showLine = true }: TodayMarkerProps) => {
  return (
    <>
      {withFill && <div className={styles['today-fill']} style={{ width: `${percent}%` }} />}
      {showLine && (
        <Tooltip
          usePortal={true}
          content={dayjs().format('DD.MM.YYYY')}
          triggerClass={styles['today-marker']}
          triggerStyle={{ left: `${percent}%` }}
        >
          <div className={styles['today-marker-line']} />
        </Tooltip>
      )}
    </>
  );
};
